import { render, staticRenderFns } from "./ShopManageAdd.vue?vue&type=template&id=10014aff&scoped=true"
import script from "./ShopManageAdd.vue?vue&type=script&lang=js"
export * from "./ShopManageAdd.vue?vue&type=script&lang=js"
import style0 from "./ShopManageAdd.vue?vue&type=style&index=0&id=10014aff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10014aff",
  null
  
)

export default component.exports